import { render, staticRenderFns } from "./FundingSetupResult.vue?vue&type=template&id=b01b28d8&scoped=true&"
import script from "./FundingSetupResult.vue?vue&type=script&lang=js&"
export * from "./FundingSetupResult.vue?vue&type=script&lang=js&"
import style0 from "./FundingSetupResult.vue?vue&type=style&index=0&id=b01b28d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b28d8",
  null
  
)

export default component.exports